var render, staticRenderFns
import script from "./frozen_detail_table.vue?vue&type=script&lang=js&"
export * from "./frozen_detail_table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8e3b921a')) {
      api.createRecord('8e3b921a', component.options)
    } else {
      api.reload('8e3b921a', component.options)
    }
    
  }
}
component.options.__file = "found/views/fee/views/record_manage/discount_manage/form/components/frozen_detail_table.vue"
export default component.exports